import { GiftTableState } from "../slices/giftTableSlice";

export const selectProductInGiftTable = (
  giftTable: GiftTableState,
  productID: string
) => giftTable.products?.find((product) => product.productID === productID);
